export default Object.freeze({
  Pending: 0,
  Processing: 1,
  Processed: 2,
  Error: 3,
  ProcessingTaskItems: 4,
  Canceled: 5,
});
